import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const CREATE_INTENT = {
  BRAND: "brand",
  ENGAGEMENT: "engagement",
  RECEIPT: "receipt",
  DEBIT: "debit",
  FABRIC: "fabric",
  DESIGN: "design",
  TASK: "task",
  ORDER: "order",
};

/**
 * Opens a page's "create" modal when it is reached via the header Create menu
 * (navigate(path, { state: { create: intent } })). The request waits until `enabled`
 * is true, so a flow whose button is disabled just lands on the page.
 */
export default function useCreateIntent(intent, open, enabled = true) {
  const location = useLocation();
  const navigate = useNavigate();
  const pending = useRef(false);

  useEffect(() => {
    if (location.state?.create !== intent) return;
    pending.current = true;
    // Clear the state so a refresh or back-navigation doesn't reopen the modal.
    navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
  }, [location.key]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (pending.current && enabled) {
      pending.current = false;
      open();
    }
  });
}
